import React, { FC, useMemo, useState } from 'react';
import { scheduledEventsQueryClient } from '../../utils/ReactQueryClients';
import { t } from 'i18next';
import { useToast } from '@thingslog/ui-components';
import { useParams } from 'react-router-dom';
import { AxiosError } from 'axios';
import ScheduledTasksHistoryTable from './components/ScheduedTasksHistoryTable';
import { PageHeader, PageHeaderControls, PortalPageShell } from '../../components';

const ScheduledTasksHistory: FC<ScheduledTasksHistoryProps> = ({}: ScheduledTasksHistoryProps) => {
  const { scheduledEventId } = useParams();
  const { toast } = useToast();
  const [errorMessage, setErrorMessage] = useState<null | string>(null);

  const headerOptions: PageHeaderControls = {
    showBackButton: true,
    showLanguageButton: true,
    showLogoutButton: true,
    showRedirectThingslogButton: true,
  };

  const { useScheduledEventsLogsForEvent } = useMemo(() => scheduledEventsQueryClient, []);
  const eventsLogQuery = useScheduledEventsLogsForEvent(Number(scheduledEventId), {
    enabled: !!scheduledEventId,
    keepPreviousData: true,
    onSuccess: () => {
      setErrorMessage(null);
    },
    onError: (error: AxiosError) => {
      const errorMessage =
        error.response?.data.errorCode === 'INVALID_INPUT'
          ? t('scheduled_tasks_could_not_find_event_with_id', { event_id: scheduledEventId })
          : t('scheduled_tasks_could_not_get_event_logs_for_event');

      setErrorMessage(errorMessage);
      toast({
        type: 'error',
        message: errorMessage,
        duration: 10000,
      });
    },
  });

  return (
    <>
      <PageHeader
        title={t('scheduled_event_history_title')}
        options={headerOptions}
        mode="sticky"
      />
      <PortalPageShell maxWidth="form" className="flex flex-col">
        <ScheduledTasksHistoryTable rows={eventsLogQuery.data ?? []} />
        {errorMessage && <div className="text-lg font-bold">{errorMessage}</div>}
      </PortalPageShell>
    </>
  );
};

interface ScheduledTasksHistoryProps {}

export default ScheduledTasksHistory;
